import { queryOptions } from '@tanstack/react-query';

import { apiClient, ICollectionResponse } from '@/resources/upgrade/jsonapi-client';
import { IBanner } from '@/resources/upgrade/Banner';

export function bannersQueryOptions() {
  return queryOptions({
    queryKey: ['banners'],
    queryFn: async () => {
      // Collection endpoint - kitsu keeps { data, meta } wrapper
      const response = await apiClient.get<ICollectionResponse<IBanner>>('banners', {
        sort: '-shown_at',
      });

      return response.data;
    },
    staleTime: 1000 * 60 * 5,
  });
}
